import Vue from 'vue'
import { util as Util, $http, getHttpClient } from './gms-util.js' //常用方法
import Vbus from './global-event-bus.js'

let GMSEnv = function() {
    this.util = Util
    this.$http = $http
    this.vbus = Vbus
    this.browserLogo = {
        logo: '',
        name: window.osConfig.title
    }
    this.getHttpClient = getHttpClient
    this.getContext = () => {
        return context
    }
}

export default function() {
    if (!window.GMS) {
        window.GMS = new GMSEnv()
        Vue.prototype.$GMS =window.GMS;
    }
}


// WEBPACK FOOTER //
// ./src/index.js